import React, { Button, Grid, Paper } from '@mui/material';
import { useState } from 'react';
import { CloseDayDialog, CloseMonthDialog, CloseWeekDialog, RecordLateSaleDialog } from 'components';

export const Administration = () => {
	const [openRecordLateSaleDialog, setOpenRecordLateSaleDialog] = useState(false);
	const [openCloseWeekDialog, setOpenCloseWeekDialog] = useState(false);
	const [openCloseMonthDialog, setOpenCloseMonthDialog] = useState(false);
	const [openCloseDayDialog, setOpenCloseDayDialog] = useState(false);
	const handleRecordLateSaleClick = () => {
		setOpenRecordLateSaleDialog(true);
		setOpenCloseMonthDialog(false);
		setOpenCloseWeekDialog(false);
		setOpenCloseDayDialog(false);
	};
	const handleCloseMonthClick = () => {
		setOpenRecordLateSaleDialog(false);
		setOpenCloseMonthDialog(true);
		setOpenCloseWeekDialog(false);
		setOpenCloseDayDialog(false);
	};
	const handleCloseWeekClick = () => {
		setOpenRecordLateSaleDialog(false);
		setOpenCloseMonthDialog(false);
		setOpenCloseWeekDialog(true);
		setOpenCloseDayDialog(false);
	};
	const handleCloseDayClick = () => {
		setOpenRecordLateSaleDialog(false);
		setOpenCloseMonthDialog(false);
		setOpenCloseWeekDialog(false);
		setOpenCloseDayDialog(true);
	};
	return (
		<>
			<Grid container p={2} component={Paper}>
				<Grid item xs={12} textAlign={'center'}>
					<h1>Administration</h1>
				</Grid>
				<Grid item xs={4} p={1}>
					<Button variant='contained' color='primary' onClick={handleCloseDayClick} fullWidth>
						Close Day
					</Button>
				</Grid>
				<Grid item xs={4} p={1}>
					<Button variant='contained' color='primary' onClick={handleCloseWeekClick} fullWidth>
						Close Week
					</Button>
				</Grid>
				<Grid item xs={4} p={1}>
					<Button variant='contained' color='primary' onClick={handleCloseMonthClick} fullWidth>
						Close Month
					</Button>
				</Grid>
				<Grid item xs={4} p={1}>
					<Button variant='contained' color='primary' onClick={handleRecordLateSaleClick} fullWidth>
						Record Late Sale
					</Button>
				</Grid>
			</Grid>
			<RecordLateSaleDialog open={openRecordLateSaleDialog} closeDialog={() => setOpenRecordLateSaleDialog(false)} />
			<CloseDayDialog open={openCloseDayDialog} closeDialog={() => setOpenCloseDayDialog(false)} />
			<CloseWeekDialog open={openCloseWeekDialog} closeDialog={() => setOpenCloseWeekDialog(false)} />
			<CloseMonthDialog open={openCloseMonthDialog} closeDialog={() => setOpenCloseMonthDialog(false)} />
		</>
	);
};
